import l, { type LoadableComponent } from "@loadable/component";
import type { LocationType, OrderDirection, ValuesOf } from "../models/enums";
import type { LocationCreateProps } from "./location/create";
import type { LocationListProps } from "./location/list";

export const AboutEdit: LoadableComponent<unknown> = l(
    () => import("./about/show"),
);

export const StoreList: LoadableComponent<unknown> = l(
    () => import("./store/list"),
);

export const AccountEdit: LoadableComponent<unknown> = l(
    () => import("./account/edit"),
);

export const BrandList: LoadableComponent<unknown> = l(
    () => import("./brand/list"),
);
export const BrandEdit: LoadableComponent<unknown> = l(
    () => import("./brand/edit"),
);
export const BrandCreate: LoadableComponent<unknown> = l(
    () => import("./brand/create"),
);

export const CardList: LoadableComponent<unknown> = l(
    () => import("./card/list"),
);
export const CardEdit: LoadableComponent<unknown> = l(
    () => import("./card/edit"),
);
export const CardCreate: LoadableComponent<unknown> = l(
    () => import("./card/create"),
);

export const CategoryList: LoadableComponent<unknown> = l(
    () => import("./category/list"),
);
export const CategoryEdit: LoadableComponent<unknown> = l(
    () => import("./category/edit"),
);

export const ContactList: LoadableComponent<unknown> = l(
    () => import("./contact/list"),
);
export const ContactEdit: LoadableComponent<unknown> = l(
    () => import("./contact/edit"),
);

export const ConversationList: LoadableComponent<unknown> = l(
    () => import("./conversation/list"),
);
export const ConversationEdit: LoadableComponent<unknown> = l(
    () => import("./conversation/edit"),
);

export const CouponList: LoadableComponent<unknown> = l(
    () => import("./coupon/list"),
);
export const CouponEdit: LoadableComponent<unknown> = l(
    () => import("./coupon/edit"),
);
export const CouponCreate: LoadableComponent<unknown> = l(
    () => import("./coupon/create"),
);

export const DepartmentList: LoadableComponent<unknown> = l(
    () => import("./department/list"),
);
export const DepartmentEdit: LoadableComponent<unknown> = l(
    () => import("./department/edit"),
);
export const DepartmentCreate: LoadableComponent<unknown> = l(
    () => import("./department/create"),
);


export const LedgerList: LoadableComponent<unknown> = l(
    () => import("./ledger/list"),
);

export const LocationList: LoadableComponent<LocationListProps> = l(
    () => import("./location/list"),
);
export const LocationEdit: LoadableComponent<{
    type?: ValuesOf<typeof LocationType>;
}> = l(() => import("./location/edit"));
export const LocationCreate: LoadableComponent<LocationCreateProps> = l(
    () => import("./location/create"),
);

export const OfferList: LoadableComponent<unknown> = l(
    () => import("./offer/list"),
);
export const OfferEdit: LoadableComponent<unknown> = l(
    () => import("./offer/edit"),
);
export const OfferCreate: LoadableComponent<unknown> = l(
    () => import("./offer/create"),
);

export const CollectionList: LoadableComponent<unknown> = l(
    () => import("./collection/list"),
);
export const CollectionEdit: LoadableComponent<unknown> = l(
    () => import("./collection/edit"),
);
export const CollectionCreate: LoadableComponent<unknown> = l(
    () => import("./collection/create"),
);

export const OrderList: LoadableComponent<{
    accountId: number;
    direction: ValuesOf<typeof OrderDirection>;
    tabs?: boolean;
}> = l(() => import("./order/list"));
export const OrderCreate: LoadableComponent<unknown> = l(
    () => import("./order/create"),
);
export const OrderEdit: LoadableComponent<unknown> = l(
    () => import("./order/edit"),
);

export const ProductList: LoadableComponent<unknown> = l(
    () => import("./product/list"),
);
export const ProductCreate: LoadableComponent<unknown> = l(
    () => import("./product/create"),
);
export const ProductEdit: LoadableComponent<unknown> = l(
    () => import("./product/edit"),
);

export const StockList: LoadableComponent<unknown> = l(
    () => import("./stock/list"),
);
export const StockEdit: LoadableComponent<unknown> = l(
    () => import("./stock/edit"),
);

export const ShiftList: LoadableComponent<unknown> = l(
    () => import("./shift/list"),
);
export const ShiftCreate: LoadableComponent<unknown> = l(
    () => import("./shift/create"),
);
export const ShiftEdit: LoadableComponent<unknown> = l(
    () => import("./shift/edit"),
);

export const BlogList: LoadableComponent<unknown> = l(
    () => import("./blog/list"),
);
export const BlogEdit: LoadableComponent<unknown> = l(
    () => import("./blog/edit"),
);
export const BlogShow: LoadableComponent<unknown> = l(
    () => import("./blog/show"),
);
export const BlogCreate: LoadableComponent<unknown> = l(
    () => import("./blog/create"),
);

export const WebsiteEdit: LoadableComponent<unknown> = l(
    () => import("./website/edit"),
);

export const ZoneList: LoadableComponent<unknown> = l(
    () => import("./zone/list"),
);
export const ZoneCreate: LoadableComponent<unknown> = l(
    () => import("./zone/create"),
);
export const ZoneEdit: LoadableComponent<unknown> = l(
    () => import("./zone/edit"),
);
